import {BreakpointObserver} from '@angular/cdk/layout';
import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Form, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators,} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {ActivatedRoute, Router} from '@angular/router';
import {ListViewComponent} from '@syncfusion/ej2-angular-lists';
import {ToastrService} from 'ngx-toastr';
import {debounceTime, map, startWith} from 'rxjs/operators';
import {DokumentModels} from 'src/app/models/dokument-models';
import {MainDataModels} from 'src/app/models/maindata-models';
import {ObjektModels} from 'src/app/models/objekt-models';
import {SwissAppConfigModels} from 'src/app/models/swissappconfig-models';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {DashboardService} from 'src/app/services/dashboard.service';
import {DokumentDataService} from 'src/app/services/dokument-data.service';
import {MainDataService} from 'src/app/services/main-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {SwissFieldBase} from 'src/app/swiss-forms/fields/swiss-field-base';
import {ObjektDialogComponent} from 'src/app/swiss-forms/objekt-dialog/objekt-dialog.component';
import {v4 as uuidv4} from 'uuid';
import {CameraViewerComponent} from '../../camera-viewer/camera-viewer.component';
import {ImageEditorComponent} from '../../image-editor/image-editor.component';
import {ObjektAdresseComponent} from '../objekt-adresse/objekt-adresse.component';
import {ObjekteBaseComponent} from '../objekte-base';
import {TreeViewItemSmall,} from '../../../services/objekt-data.service';
import {AufgabeEintragComponent} from '../../pendenzen/aufgabe-eintrag/aufgabe-eintrag.component';
import {NotizEintragComponent} from '../../pendenzen/notiz-eintrag/notiz-eintrag.component';
import {TerminEintragComponent} from '../../pendenzen/termin-eintrag/termin-eintrag.component';
import {SpeedDialItemEventArgs, SpeedDialItemModel} from '@syncfusion/ej2-angular-buttons';
import {UserAuthenticationService} from '../../../services/user-authentication.service';
import {HelperService} from '../../../services/helper.service';
import {TreeviewService} from '../../../services/treeview.service';
import {PDFViewerDialogComponent} from '../../../pdfviewer/pdfviewerDialog.component';

@Component({
    selector: 'app-objekte-mobile', templateUrl: './objekte-mobile.component.html', styleUrls: ['./objekte-mobile.component.scss'],
})
export class ObjekteMobileComponent extends ObjekteBaseComponent implements OnInit {
    objekte: Array<MainDataModels.SearchFieldResponseObjekt> = []; // Leeres Objekte-Array erstellen (SearchFieldResponseObjekt[])

    treeViewItemsBottomUp: Array<TreeViewItemSmall> = [];
    treeViewItemsTopDown: Array<TreeViewItemSmall> = [];
    public cssClass = 'custom';
    @ViewChild('objektForm') objektForm?: ElementRef<Form>;
    @ViewChild('objListView') objListView?: ListViewComponent;
    @Input() swissFields: SwissFieldBase<any>[] = [];

    mySwissFieldsObjectDetailLinks?: SwissFieldBase<any>[] = [];
    mySwissFieldsObjectDetailRechts?: SwissFieldBase<any>[] = [];
    mySwissFieldsObjectExtensionLinks?: SwissFieldBase<any>[] = [];
    mySwissFieldsObjectExtensionRechts?: SwissFieldBase<any>[] = [];
    allDynamicObjectFields?: SwissFieldBase<any>[] = [];

    @Input() isDialog: boolean;
    formGrp!: UntypedFormGroup;
    /* Datenstatus */
    objectDataLoaded = false;
    currObjektOfflineStatus?: ObjektModels.ObjektOfflineStatus;
    updatedFieldKey = '';
    /* Objektbaum */
    selectedTreeViewItem = '';
    /* Objekt ListView */
    dataSourceObjListView: ObjektModels.ObjectListViewItem[] = [];
    fieldsObjView: Object = {
        id: 'objectID', text: 'objectNumber', groupBy: 'objectTypeDesc',
    };
    disableObjectStructureControl = true;
    myControl: UntypedFormControl;
    manuDesc: UntypedFormControl;
    memo: UntypedFormControl;
    filteredDescriptions?: MainDataModels.SearchFieldResponseObjekt[];
    /* ObjektAdressen */
    displayedObjAdrColumns: string[] = [// 'adrtyp',
        'kombiname', 'street', 'plz/ort', // 'city',
        // 'telefon',
        // 'anrede',
        // 'email',
        // 'natel',
        // 'menuOA',
    ];
    selectedObjektAdressID = '';
    /* Objekt-Aktivitäten (Dokumente) */
    dataSourceObjektAktivitaeten: MatTableDataSource<ObjektModels.ObjektAktivitaetListElement>;
    hasObjektDokus = 0; // 0: nein | 1: ja
    displayedObjDokuColumns: string[] = ['doku_art', 'doku_bearbeitet', 'doku_desc', 'doku_name', // 'doku_vorname',
        // 'doku_ansprechname',
        // 'doku_ansprechvorname',
        'menuBild',];
    // displayedObjDokuColumns: string[] = ['doku_art', 'doku_desc', 'doku_name', 'doku_vorname', 'doku_ansprechname', 'doku_ansprechvorname', 'doku_erstellt', 'doku_ersteller', 'doku_bearbeitet', 'doku_bearbeiter'];
    selectedObjektDocumentID = '';
    currObjektID: any = '';
    objektAktivitaeten: ObjektModels.ObjektAktivitaetListElement[] = [];
    // Panel-Header Grösse
    expandPanelHeaderExpandendHeight = '42px';
    expandPanelHeaderCollapsedHeight = '42px';
    public showObjektBaum = true;
    /// Custom Mario
    public toggle = 'suchen';
    filterValue!: string;
    searchField!: any;
    selectedAdressID!: string;
    headerTitle = 'Objekt suchen';
    prevToggleValue: string[] = ['suchen'];
    public menuItems: SpeedDialItemModel[] = [];

    /* RichtText Editor */
    public tools: object = {
        items: ['Undo', 'Redo', '|', 'Bold', 'Italic', 'Underline', 'StrikeThrough', '|', 'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|', 'SubScript', 'SuperScript', '|', 'LowerCase', 'UpperCase', '|', 'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|', 'Indent', 'Outdent', '|', 'CreateLink', 'Image', '|', 'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen',],
    };
    public height = 200;
    public field: Object = {
        dataSource: [], id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild', expanded: 'expanded', imageUrl: 'imageURL',
    };
    public fieldTopDown: Object = {
        dataSource: this.treeViewItemsTopDown, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild', expanded: 'expanded', imageUrl: 'imageURL',
    };
    public fieldBottomUp: Object = {
        dataSource: this.treeViewItemsBottomUp, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild', expanded: 'expanded', imageUrl: 'imageURL',
    };
    /* Neue Notiz erstellen */
    private dataForCalendarNote?: MainDataModels.NotizMitBenutzer;
    private currNotizMitBenutzern?: MainDataModels.NotizMitBenutzer;
    private currTerminMitBenutzern?: MainDataModels.TerminMitBenutzer;
    private currAufgabeMitBenutzern?: MainDataModels.AufgabeMitBenutzer;

    ///
    private objektAdresseDialogInput?: ObjektModels.ObjektAdresseDialogInput;
    private sub: any;
    /* PDF-Erzeugung */
    private pencilNote?: ObjektModels.PencilNotes;
    private swissAppConfig!: SwissAppConfigModels.SwissAppConfig;
    private swissAppUserConfig!: SwissAppConfigModels.SwissAppUserConfig;

    constructor(public treeViewCache: TreeviewService, public svcObjekte: ObjektDataService, public svcDokuData: DokumentDataService, private svcMainData: MainDataService, public svcMessageBox: MessageBoxService, public userAuthService: UserAuthenticationService, // private homeLayoutComponent: HomeLayoutComponent,
                public breakpointObserver: BreakpointObserver, public dialog: MatDialog, private fb: UntypedFormBuilder, public _datumFormatPipe: DatumFormatPipe, public swissSettings: SwissSettingsService, private router: Router, private route: ActivatedRoute, private toastr: ToastrService, private svcObjektData: ObjektDataService, private svcDashboard: DashboardService, public helperService: HelperService) {
        super(svcObjekte, _datumFormatPipe, userAuthService, swissSettings, svcDokuData, svcMessageBox, helperService, treeViewCache);
        // Wurde der Browser aktualisiert?
        this.helperService.setPageRefreshURL('/objekte-mobile').then(() => {
            if (this.userAuthService.getCurrentAuthenticatedUser() == undefined) {
                this.router.navigate(['']);
            }
        });

        this.currObjekt = ObjektModels.EmptyObjektElement();
        this.myControl = new UntypedFormControl();
        this.manuDesc = new UntypedFormControl();
        this.memo = new UntypedFormControl();
        this.isDialog = false;
        this.formGrp = this.fb.group({});
        this.formGrp.addControl('manuDesc', this.manuDesc);
        this.formGrp.addControl('memo', this.memo);

        this.dataSourceObjektAdressen = new MatTableDataSource<ObjektModels.ObjektAdresse>();
        this.dataSourceObjektAktivitaeten = new MatTableDataSource<ObjektModels.ObjektAktivitaetListElement>();
        this.initUserRights();
    }

    ngOnInit(): void {
        this.svcObjekte.registerObjActivitiesFunc(this.reloadObjektAktivitaeten.bind(this));

        this.swissSettings.waitForSwissAppConfigs().then(() => {
            this.swissAppConfig = this.swissSettings.getSwissAppConfig();
            this.swissAppUserConfig = this.swissSettings.getSwissAppUserConfig();
            this.showObjektBaum = this.swissSettings.getObjViewConfig() === 1;

            if (this.showObjektBaum) {
                this.svcObjekte.loadObjektTypes().then((res: any) => {
                    if (res) {
                        // Anzeige mit Objektbaum
                        this.refreshObjektBaum().then((res) => {
                            if (res) {
                                this.initData();
                            }
                        });
                    }
                });
            } else {
                // Anzeige mit Objektliste
                this.svcObjekte.getObjectView(this.swissSettings.getObjViewConfig()).subscribe({
                    next: (res: ObjektModels.ObjectListViewItem[]) => {
                        if (res) {
                            this.dataSourceObjListView = res;
                            this.dataSubject.next({data: res, online: true});
                            this.initData();
                        }
                    }, error: (error: string) => {
                        console.error('Fehler beim Ermitteln der ObjektView: ' + error);
                        this.svcMessageBox.showError('Fehler beim Ermitteln der ObjektView: ' + error, '!! Fehler !!');
                    }
                });
            }

            this.myControl.valueChanges
                .pipe(startWith(''), map((value) => {
                    // Erst ab einem Zeichen filtern
                    if (value.length > 0) {
                        this.filteredDescriptions = this.objekte.filter((o) => o.beschreibung.toLowerCase().startsWith(value.toLowerCase()));
                    } else {
                        this.filteredDescriptions = [];
                    }
                }))
                .subscribe();
        });

        this.route.params.subscribe({
            next: (params) => {
                if (params.id) {
                    this.currObjektID = params.id;
                    this.loadSingleObjekt();
                    this.toggleBtn('objektansicht');
                }
            },
        });
    }

    public speedMenuClicked(args: SpeedDialItemEventArgs): void {
        switch (args.item.id) {
            case (args.item.id = 'new.obj'):
                this.onNewObjekt();
                break;
            case (args.item.id = 'dashboard'):
                this.router.navigateByUrl('/dashboard-mobile');
                break;
            case (args.item.id = 'logout'):
                this.userAuthService.logoutUser('/login');
                break;

            default:
                return;
        }
    }

    checkInnerWidth(): boolean {
        return window.innerWidth <= 480;
    }

    public speedMenuCreated(): void {
        this.menuItems = [];
        this.menuItems.push({text: 'Dashboard', id: 'dashboard'});
        this.menuItems.push({text: 'Abmelden', id: 'logout'});
    }

    applyFilter(value: any) {
        this.filterValue = value.trim().toLowerCase();

        this.filteredDescriptions = this.objekte.filter((el) => {
            return (el.beschreibung.toLowerCase().includes(this.filterValue) || el.objectID!.toLowerCase().includes(this.filterValue));
        });
    }

    clearInput() {
        this.searchField = '';
        this.filteredDescriptions = this.objekte;
    }

    highlight(row: any) {
        this.selectedAdressID = row.objectID;
        this.currObjektID = row.objectID;
        this.loadSingleObjekt();
    }

    saveObjekt(): void {
        // Das dynamische Form ruft diese Methode auf, wenn es auf einem Feld eine Änderung gab.
        this.onSubmit();
    }

    refreshObjektBaumBottomUp(): Promise<boolean> {
        return new Promise((resolve) => {
            this.treeViewItemsBottomUp = [];
            this.svcObjekte.getObjektBaumBottomUp(this.currObjektID).subscribe({
                next: (res: any) => {
                    this.treeViewItemsBottomUp = this.treeViewItemsBottomUp.concat(res);
                    this.fieldBottomUp = {
                        dataSource: this.treeViewItemsBottomUp, id: 'objectID', parentID: 'parentObject', text: 'name', hasChildren: 'hasChild', expanded: 'expanded', imageUrl: 'imageURL',
                    };
                    if (this.swissSettings.getWebConfig().debugMode) {
                        resolve(true);
                    }
                },
            });
        });
    }

    refreshObjektBaumTopDown(): Promise<boolean> {
        return new Promise((resolve) => {
            this.treeViewItemsTopDown = [];
            this.svcObjekte.getObjektBaumTopDown(this.currObjektID).subscribe({
                next: (res: any) => {
                    this.treeViewItemsTopDown = this.treeViewItemsTopDown.concat(res);
                    this.fieldTopDown = {
                        dataSource: this.treeViewItemsTopDown, id: 'objectID', parentID: 'parentObject', text: 'name', hasChildren: 'hasChild', expanded: 'expanded', imageUrl: 'imageURL',
                    };
                    resolve(true);
                },
            });
        });
    }

    addSuchfeldBeschreibungen(searchFieldResponseObjekt: MainDataModels.SearchFieldResponseObjekt) {
        this.objekte.push(searchFieldResponseObjekt);
    }

    removeSuchfeldBeschreibungen() {
        const index = this.objekte.findIndex((o) => o.objectID === this.currObjektID);
        if (index > -1) {
            // Objekt aus Array löschen
            this.objekte.splice(index, 1);
        }
    }

    refreshSuchfeldBeschreibungen() {
        this.objekte = [];
        this.svcObjekte
            .getSuchfeldBeschreibungen()
            .subscribe({
                next: // (res: ConcatArray<MainDataModels.SearchFieldResponseObjekt>) => {
                    (res: any) => {
                        this.objekte = this.objekte.concat(res);
                        // Custom Mario
                        this.filteredDescriptions = this.objekte;
                        this.svcObjekte.saveSuchfeldBeschreibungen(this.objekte);
                    },
            });
    }

    refreshOfflineSuchfeldBeschreibungen() {
        // Nur noch ObjekteBezeichnungen für Suche laden, die Offline verfügbar sein sollen
        this.objekte = [];
        this.svcObjekte
            .getOfflineSuchfeldBeschreibungen()
            .then((value: ConcatArray<MainDataModels.SearchFieldResponseObjekt>) => {
                this.objekte = this.objekte.concat(value);
            });
    }

    addAllFieldsToFormGroup(allDynFields: SwissFieldBase<any>[]) {
        allDynFields.forEach((formItem) => {
            const formControl = this.fb.control(formItem.options.value, formItem.options.required ? Validators.required : null);
            this.formGrp.addControl(formItem.options.key!, formControl);
        });
    }

    loadFormFields() {
        return new Promise((resolve) => {
            this.formGrp = this.fb.group({});
            this.formGrp.addControl('manuDesc', this.manuDesc, {emitEvent: false});
            this.formGrp.addControl('memo', this.memo, {emitEvent: false});

            const objType = this.currObjekt.objectType;
            this.svcObjekte.getFormFieldsByObjType(1, objType).subscribe({
                next: async (res: any[]) => {
                    if (res) {
                        await this.svcObjekte.setOfflineFormFields(1, objType, res);
                        res.forEach((field: { isNewEntity: boolean }) => (field.isNewEntity = false));
                        // Alle Felder der Gruppe "Objektdetails" hinzufügen
                        this.addAllFieldsToFormGroup(res);
                        this.mySwissFieldsObjectDetailLinks = res.filter((f: { options: { location: number } }) => f.options.location === 1);
                        this.mySwissFieldsObjectDetailRechts = res.filter((f: { options: { location: number } }) => f.options.location === 2);

                        this.mySwissFieldsObjectDetailLinks = this.mySwissFieldsObjectDetailLinks!.sort((a, b) => a.options.order! - b.options.order!);
                        this.mySwissFieldsObjectDetailRechts = this.mySwissFieldsObjectDetailRechts!.sort((a, b) => a.options.order! - b.options.order!);

                        this.mySwissFieldsObjectDetailLinks.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                        this.mySwissFieldsObjectDetailRechts.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));

                        this.svcObjekte.getFormFieldsByObjType(2, objType).subscribe({
                            next: async (res2: any[]) => {
                                if (res2) {
                                    await this.svcObjekte.setOfflineFormFields(2, objType, res2);
                                    res2.forEach((field: { isNewEntity: boolean }) => (field.isNewEntity = false));
                                    // Alle Felder der Gruppe "Objekterweiterung" hinzufügen
                                    this.addAllFieldsToFormGroup(res2);
                                    this.mySwissFieldsObjectExtensionLinks = res2.filter((f: { options: { location: number } }) => f.options.location === 1);
                                    this.mySwissFieldsObjectExtensionRechts = res2.filter((f: { options: { location: number } }) => f.options.location === 2);

                                    this.mySwissFieldsObjectExtensionLinks = this.mySwissFieldsObjectExtensionLinks!.sort((a, b) => a.options.order! - b.options.order!);
                                    this.mySwissFieldsObjectExtensionRechts = this.mySwissFieldsObjectExtensionRechts!.sort((a, b) => a.options.order! - b.options.order!);

                                    this.mySwissFieldsObjectExtensionLinks.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                                    this.mySwissFieldsObjectExtensionRechts.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                                    if (this.swissSettings.getWebConfig().debugMode) {
                                        console.log('Formfelder geladen.', this.allDynamicObjectFields);
                                    }

                                    resolve(new Response('Formfields loaded'));
                                }
                            }, error: (error: any) => console.error('Fehler bei der Ermittlung von Feldern (Objektdetails). ', error),
                        });
                    }
                }, error: (error: any) => console.error('Fehler bei der Ermittlung von Feldern. (Objekterweiterung) ', error),
            });
        });
    }

    loadOfflineFormFields() {
        return new Promise((resolve) => {
            const objectType = parseInt(this.currObjekt.objectType, 10);
            this.svcObjekte
                .getOfflineFormFields(1, objectType)
                .then((res: any[] | null) => {
                    if (res) {
                        res.forEach((field: { isNewEntity: boolean }) => (field.isNewEntity = false));
                        // Alle Felder der Gruppe "Objekterdetails" hinzufügen
                        this.addAllFieldsToFormGroup(res);
                        this.mySwissFieldsObjectDetailLinks = res.filter((f: { options: { location: number } }) => f.options.location === 1);
                        this.mySwissFieldsObjectDetailRechts = res.filter((f: { options: { location: number } }) => f.options.location === 2);

                        this.mySwissFieldsObjectDetailLinks = this.mySwissFieldsObjectDetailLinks!.sort((a, b) => a.options.order! - b.options.order!);
                        this.mySwissFieldsObjectDetailRechts = this.mySwissFieldsObjectDetailRechts!.sort((a, b) => a.options.order! - b.options.order!);

                        this.mySwissFieldsObjectDetailLinks.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                        this.mySwissFieldsObjectDetailRechts.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                        this.svcObjekte.getOfflineFormFields(2, objectType)
                            .then((res2: any[] | null) => {
                                if (res2) {
                                    res2.forEach((field: { isNewEntity: boolean }) => (field.isNewEntity = false));
                                    // Alle Felder der Gruppe "Objekterweiterung" hinzufügen
                                    this.addAllFieldsToFormGroup(res2);
                                    this.mySwissFieldsObjectExtensionLinks = res2.filter((f: { options: { location: number } }) => f.options.location === 1);
                                    this.mySwissFieldsObjectExtensionRechts = res2.filter((f: { options: { location: number } }) => f.options.location === 2);

                                    this.mySwissFieldsObjectExtensionLinks = this.mySwissFieldsObjectExtensionLinks!.sort((a, b) => a.options.order! - b.options.order!);
                                    this.mySwissFieldsObjectExtensionRechts = this.mySwissFieldsObjectExtensionRechts!.sort((a, b) => a.options.order! - b.options.order!);

                                    this.mySwissFieldsObjectExtensionLinks.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                                    this.mySwissFieldsObjectExtensionRechts.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                                    if (this.swissSettings.getWebConfig().debugMode) {
                                        console.log('Formfelder geladen.');
                                    }
                                    resolve(new Response('Formfields loaded'));
                                }
                            });
                    }
                });
        });
    }


    getObjektDesc(item: MainDataModels.SearchFieldResponseObjekt) {
        if (item) {
            return item.beschreibung;
        } else {
            return '';
        }
    }

    loadObjektAditionalData(blShowObjektInTreeview: boolean) {
        this.allDynamicObjectFields = [];

        // Formularwerte neu setzen --> DataBinding
        this.fillFormDataValues();
        // Objektadressen laden
        this.reloadObjektAdressen();
        // Objekt-Aktivitäten (Dokumente) laden
        this.reloadObjektAktivitaeten();

        // Berechtigungen anhand Betriebsteile (Company parts ermitteln)
        this.reloadObjektBerechtigungen();

        if (blShowObjektInTreeview) {
            if (this.showObjektBaum) {
            } else {
                this.refreshObjektBaumBottomUp().then(() => {
                    this.refreshObjektBaumTopDown();
                });
            }
        }
    }

    // Suchelement wurde angeklickt
    selectedSearchItem(event: any) {
        if (event) {
            this.currObjektID = event.option.value;
            this.loadSingleObjekt(true);
        }
    }

    cleanObjectData() {
        this.currObjekt = ObjektModels.EmptyObjektElement();
        this.currObjektID = '';
        this.hasObjektDokus = 0;
        this.hasObjektPartner = 0;
        this.dataSourceObjektAdressen = new MatTableDataSource<ObjektModels.ObjektAdresse>();
        this.dataSourceObjektAktivitaeten = new MatTableDataSource<ObjektModels.ObjektAktivitaetListElement>();
        this.objectDataLoaded = false;
        this.selectedTreeViewItem = '';
        this.setExpandStateObjektDetails(1);
        this.setExpandStateObjektErweiterung(1);
        this.setExpandStateObjektAktivitaeten(1);
        this.setExpandStateObjektAdressen(1);
        this.setExpandStateObjektDokuInfos(1);
        this.setExpandStateObjektStruktur(1);
    }

    nodeclicked() {
        this.loadSingleObjekt(true);
    }

    listViewItemclicked(event: any) {
        if (this.objListView && event.data) {
            this.currObjektID = event.data.objectID;
            this.loadSingleObjekt(true);
        }
    }

    nodesExpanded(event: any) {
        if (this.treeView && this.selectedTreeViewItem) {
            this.treeView!.ensureVisible(this.selectedTreeViewItem);
            this.listViewItemclicked(event);
        }
    }

    editAppointment(calendarID: string) {
        this.svcMainData.loadTerminByID(calendarID).subscribe({
            next: (res) => {
                const dialogRef = this.dialog.open(TerminEintragComponent, {
                    disableClose: true, width: '800px', data: res,
                });

                dialogRef.afterClosed().subscribe({
                    next: (result) => {
                        this.currTerminMitBenutzern = result;
                        if (this.currTerminMitBenutzern) {
                            // Update Informations
                            this.svcMainData
                                .saveTermin(this.currTerminMitBenutzern)
                                .subscribe({
                                    next: () => {
                                        this.svcMessageBox.showSuccess('Der Termin wurde erfolgreich aktualisiert.', 'Erfolgreich');
                                        this.svcMainData.reloadCalendarData();
                                        this.reloadObjektAktivitaeten();
                                    }, error: (error) => {
                                        console.error('editAppointment: ', error);
                                        this.svcMessageBox.showError('Der Termin konnte nicht angepasst werden!!', '!! FEHLER !!');
                                    },
                                });
                            if (this.swissSettings.getWebConfig().debugMode) {
                                console.log('Dialog Resultat (currTerminMitBenutzern): ', this.currTerminMitBenutzern);
                            }
                        }
                    },
                });
            },
        });
    }

    editNote(noteID: string) {
        this.svcMainData.loadNoteByID(noteID).subscribe({
            next: (res) => {
                const dialogRef = this.dialog.open(NotizEintragComponent, {
                    disableClose: true, data: res,
                });

                dialogRef.afterClosed().subscribe({
                    next: (result) => {
                        this.currNotizMitBenutzern = result;
                        if (this.currNotizMitBenutzern) {
                            // Update Information
                            this.svcMainData.saveNotiz(this.currNotizMitBenutzern).subscribe({
                                next: () => {
                                    this.svcMessageBox.showSuccess('Die Notiz wurde erfolgreich gespeichert.', 'Erfolgreich');
                                    this.reloadObjektAktivitaeten();
                                    this.svcMainData.refreshNoteCount();
                                }, error: (error) => {
                                    console.error(error);
                                    this.svcMessageBox.showError('Die Notiz konnte nicht gespeichert werden!!', '!! FEHLER !!');
                                },
                            });
                            if (this.swissSettings.getWebConfig().debugMode) {
                                console.log('Dialog Resultat (currNotizMitBenutzern): ', this.currNotizMitBenutzern);
                            }
                        }
                    },
                });
            },
        });
    }

    editTask(taskID: string) {
        this.svcMainData.loadTaskByID(taskID).subscribe({
            next: (res) => {
                const dialogRef = this.dialog.open(AufgabeEintragComponent, {
                    disableClose: true, width: '800px', height: '90vh', data: res,
                });

                return dialogRef.afterClosed().subscribe({
                    next: (result) => {
                        if (result) {
                            this.currAufgabeMitBenutzern = result;
                            // Update Informations
                            if (this.currAufgabeMitBenutzern) {
                                this.svcMainData
                                    .saveAufgabe(this.currAufgabeMitBenutzern)
                                    .subscribe({
                                        next: () => {
                                            this.svcMessageBox.showSuccess('Die Aufgabe wurde erfolgreich gespeichert.', 'Erfolgreich');
                                            this.reloadObjektAktivitaeten();
                                        }, error: (error) => {
                                            console.error(error);
                                            this.svcMessageBox.showError('Die Aufgabe konnte nicht gespeichert werden!!', '!! FEHLER !!');
                                        },
                                    });
                            }
                            if (this.swissSettings.getWebConfig().debugMode) {
                                console.log('Dialog Resultat (currAufgabeMitBenutzern): ', this.currAufgabeMitBenutzern);
                            }
                        }
                    },
                });
            },
        });
    }


    fillFormDataValuesByType(swissFields: SwissFieldBase<any>[]) {
        for (const swissField of swissFields) {
            // Aus DropDown-Feldern wird ein Textfeld gemacht... dann muss nicht die ID, sonder der Wert geladen werden.
            // Vor allem wichtig beim Objekt-Typen
            if (swissField.controlType === 'dropdown') {
                if (swissField.options.readOnly) {
                    if (swissField.options.optionsBestehend) {
                        const value = this.currObjekt[swissField.options.dataBinding as keyof ObjektModels.ObjektElement];
                        swissField.options.value = swissField.options.optionsBestehend.filter((x: { key: string | number | Date | undefined }) => x.key == value)[0].value;
                    }
                } else {
                    const value = this.currObjekt[swissField.options.dataBinding as keyof ObjektModels.ObjektElement];
                    if (value) {
                        swissField.options.value = String(value);
                    }
                }
            } else if (swissField.controlType === 'date_with_time') {
                const dateString = this.currObjekt[swissField.options.dataBinding as keyof ObjektModels.ObjektElement];
                if (dateString) {
                    swissField.options.value = this.formatDate(new Date(String(dateString)));
                }
            } else {
                swissField.options.value = this.currObjekt[swissField.options.dataBinding as keyof ObjektModels.ObjektElement];
            }
        }
        // Array kopieren
        swissFields.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('Felddaten zu Objektdetails geladen.');
        }
    }

    fillFormDataValues() {
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('fillFormDataValues vor loadFormFields promise');
        }
        this.loadFormFields().then(() => {
            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('fillFormDataValues promise');
            }

            this.allDynamicObjectFields = [];

            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('fillFormDataValues', this.formGrp.controls);
            }

            if (this.mySwissFieldsObjectDetailLinks) {
                this.fillFormDataValuesByType(this.mySwissFieldsObjectDetailLinks);
            }

            if (this.mySwissFieldsObjectDetailRechts) {
                this.fillFormDataValuesByType(this.mySwissFieldsObjectDetailRechts);
            }

            if (this.mySwissFieldsObjectExtensionLinks) {
                this.fillFormDataValuesByType(this.mySwissFieldsObjectExtensionLinks);
            }

            if (this.mySwissFieldsObjectExtensionRechts) {
                this.fillFormDataValuesByType(this.mySwissFieldsObjectExtensionRechts);
            }

            // Geladene Daten dem Form hinzufügen
            this.resetFormGroup();

            // Berechtigungen und Event-Handling setzen
            this.setFieldUserRights();
            this.objectDataLoaded = true;
        });
    }

    setFieldUserRights() {
        if (!this.rechtObjektMutieren) {
            Object.keys(this.formGrp.controls).forEach((key) => {
                this.formGrp.controls[key].disable({onlySelf: true});
            });
        } else {
            // Auf Änderungen reagieren, wenn es kein neues Objekt ist (Auftrag / ProdAuftrag)
            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('setFieldUserRights(): allDynamicObjectFields', this.allDynamicObjectFields);
            }
            Object.keys(this.formGrp.controls).forEach((key) => {
                if (key !== 'manuDesc' && key !== 'memo') {
                    this.formGrp
                        .get(key)
                        ?.valueChanges.pipe(debounceTime(300))
                        .subscribe({
                            next: (data) => {
                                if (this.swissSettings.getWebConfig().debugMode) {
                                    console.log('Data', data, key);
                                }
                                this.updatedFieldKey = key;
                                this.onSubmit();
                            },
                        });
                }
            });
        }
    }

    fillOfflineFormDataValues() {
        this.loadOfflineFormFields().then(() => {
            this.allDynamicObjectFields = [];

            if (this.mySwissFieldsObjectDetailLinks) {
                for (const swissField of this.mySwissFieldsObjectDetailLinks) {
                    swissField.options.value = this.currObjekt[swissField.options.dataBinding as keyof ObjektModels.ObjektElement];
                }
                // Array kopieren
                this.mySwissFieldsObjectDetailLinks.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('Felddaten zu Objektdetails geladen.');
                }
            }

            if (this.mySwissFieldsObjectDetailRechts) {
                for (const swissField of this.mySwissFieldsObjectDetailRechts) {
                    swissField.options.value = this.currObjekt[swissField.options.dataBinding as keyof ObjektModels.ObjektElement];
                }
                // Array kopieren
                this.mySwissFieldsObjectDetailRechts.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('Felddaten zu Objektdetails geladen.');
                }
            }

            if (this.mySwissFieldsObjectExtensionLinks) {
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('Objekt', this.currObjekt);
                }
                for (const swissField of this.mySwissFieldsObjectExtensionLinks) {
                    if (this.swissSettings.getWebConfig().debugMode) {
                        console.log('swissField', swissField);
                    }
                    const test = this.currObjekt[swissField.options.dataBinding as keyof ObjektModels.ObjektElement];
                    if (this.swissSettings.getWebConfig().debugMode) {
                        console.log('Wert', test);
                    }
                    swissField.options.value = test;
                }
                // Array kopieren
                this.mySwissFieldsObjectExtensionLinks.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('Felddaten zu Objekterweiterung geladen.');
                }
            }

            if (this.mySwissFieldsObjectExtensionRechts) {
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('Objekt', this.currObjekt);
                }
                for (const swissField of this.mySwissFieldsObjectExtensionRechts) {
                    if (this.swissSettings.getWebConfig().debugMode) {
                        console.log('swissField', swissField);
                    }
                    const test = this.currObjekt[swissField.options.dataBinding as keyof ObjektModels.ObjektElement];
                    if (this.swissSettings.getWebConfig().debugMode) {
                        console.log('Wert', test);
                    }
                    swissField.options.value = test;
                }
                // Array kopieren
                this.mySwissFieldsObjectExtensionRechts.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('Felddaten zu Objekterweiterung geladen.');
                }
            }

            // Geladene Daten dem Form hinzufügen
            this.resetFormGroup();

            // Berechtigungen und Event-Handling setzen
            this.setFieldUserRights();
            this.objectDataLoaded = true;
        });
    }

    objDetailsTabChange(event: MatTabChangeEvent) {
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('CurrentElement', this.currObjekt);
        }
        if (event.index === 1) {
            // Register Produktionsbeschrieb
            this.rteObj1?.refreshUI();
        } else if (event.index === 2) {
            this.rteObj2?.refreshUI();
        }
    }

    openObjektDialog(dialogData: ObjektModels.ObjektDialogInput) {
        const dialogRef = this.dialog.open(ObjektDialogComponent, {
            disableClose: true, data: dialogData, closeOnNavigation: true
        });

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.currObjekt = result;
                    if (this.swissSettings.getWebConfig().debugMode) {
                        console.log('Nach neuem Auftrag', this.currObjekt);
                    }

                    // via Service den anderen Komponenten das Objekt mitteilen
                    this.svcObjekte.setCurrentObject(this.currObjekt);

                    if (this.showObjektBaum) {
                        /*this.addObjektToBaum().then((res2) => {
                            if (res2) {
                                // Suchbeschreibungen erweitern
                                this.addSuchfeldBeschreibungen({
                                    objectID: this.currObjekt.objectID, beschreibung: this.currObjekt.description,
                                });
                                this.currObjektID = this.currObjekt.objectID;
                                this.loadSingleObjekt(true);
                            }
                        });*/
                    } else {
                        // Suchbeschreibungen erweitern
                        this.addSuchfeldBeschreibungen({
                            objectID: this.currObjekt.objectID, beschreibung: this.currObjekt.description,
                        });
                        this.currObjektID = this.currObjekt.objectID;
                        this.loadSingleObjekt(true);
                    }
                }
            },
        });
    }

    onNewObjekt() {
        this.onNewBaseObjekt();
        const myData: ObjektModels.ObjektDialogInput = {
            parentObjectID: this.currObjektID,
        };
        this.openObjektDialog(myData);
    }

    onDelObjekt() {
        if (this.currObjekt.objectID != '') {
            this.svcObjekte
                .checkObjectDeleteRequest(this.currObjekt.objectID)
                .subscribe({
                    next: (res: ObjektModels.ObjektReferenzInfos) => {
                        const objRefInfos: ObjektModels.ObjektReferenzInfos = res;

                        if (objRefInfos.hatUnterobjekte === 1) {
                            this.svcMessageBox.showInfo('Das Objekt hat untergeordnete Objekte und kann nicht gelöscht werden.', 'Löschen nicht möglich');
                        } else if (objRefInfos.anzDokumente > 0 || objRefInfos.anzAufgaben > 0 || objRefInfos.anzNotizen > 0 || objRefInfos.anzTermine > 0 || objRefInfos.anzZeitkontrolle > 0 || objRefInfos.anzAuslastungsplanung > 0 || objRefInfos.anzEinsatzplanung > 0) {
                            // Frage generieren
                            const ausgabeListe: string[] = [];
                            if (objRefInfos.anzDokumente > 0) {
                                ausgabeListe.push('Anzahl Dokumente: ' + objRefInfos.anzDokumente);
                            }
                            if (objRefInfos.anzAufgaben > 0) {
                                ausgabeListe.push('Anzahl Aufgaben: ' + objRefInfos.anzAufgaben);
                            }
                            if (objRefInfos.anzNotizen > 0) {
                                ausgabeListe.push('Anzahl Notizen: ' + objRefInfos.anzNotizen);
                            }
                            if (objRefInfos.anzTermine > 0) {
                                ausgabeListe.push('Anzahl Termine: ' + objRefInfos.anzTermine);
                            }
                            if (objRefInfos.anzZeitkontrolle > 0) {
                                ausgabeListe.push('Anzahl Einträge in Zeitkontrolle: ' + objRefInfos.anzZeitkontrolle);
                            }
                            if (objRefInfos.anzAuslastungsplanung > 0) {
                                ausgabeListe.push('Anzahl Einträge in Auslastungsplanung: ' + objRefInfos.anzAuslastungsplanung);
                            }
                            if (objRefInfos.anzEinsatzplanung > 0) {
                                ausgabeListe.push('Anzahl Einträge in Einsatzplanung: ' + objRefInfos.anzEinsatzplanung);
                            }

                            this.svcMessageBox
                                .askYesNoQuestionWithList('MAIN_APP_DIALOG.DEL_OBJ_REF.msg', 'MAIN_APP_DIALOG.DEL_OBJ_REF.title', ausgabeListe, [this.currObjekt.objectNumber, this.currObjekt.description])
                                .then((value) => {
                                    if (value) {
                                        this.delObjekt();
                                    }
                                });
                        } else {
                            this.svcMessageBox
                                .askYesNoQuestion('MAIN_APP_DIALOG.DEL_OBJ.msg', 'MAIN_APP_DIALOG.DEL_OBJ.title', [this.currObjekt.objectNumber, this.currObjekt.description])
                                .then((value) => {
                                    if (value) {
                                        this.delObjekt();
                                    }
                                });
                        }
                    }, error: (err: any) => {
                        console.error('checkObjectDeleteRequest - Fehler', err);
                        this.svcMessageBox.showError('Die Objektreferenzen für das Löschen des Objekts konnten nicht ermittelt werden!!', '!! FEHLER !!');
                    }
                });
        }
    }

    onNewAuftrag() {
        this.onNewBaseObjekt();
        const myData: ObjektModels.ObjektDialogInput = {
            parentObjectID: this.currObjektID, objectType: '2',
        };
        this.openObjektDialog(myData);
    }

    onNewProdAuftrag() {
        this.onNewBaseObjekt();
        const myData: ObjektModels.ObjektDialogInput = {
            parentObjectID: this.currObjektID, objectType: '4',
        };
        this.openObjektDialog(myData);
    }

    saveDefaultFormValuesToObject() {
        console.log('saveDefaultFormValuesToObject: ', this.formGrp);
        // Produktionsbeschrieb
        if (this.formGrp.contains('manuDesc')) {
            const value = this.formGrp.value['manuDesc' as keyof ObjektModels.ObjektElement];
            if (value) {
                this.currObjekt.manufacturingDescription = value;
            }
        }

        // Notizen
        if (this.formGrp.contains('memo')) {
            const value = this.formGrp.value['memo' as keyof ObjektModels.ObjektElement];
            if (value) {
                this.currObjekt.memo = value;
            }
        }
    }

    saveFormValuesToObject(mySwissFields?: SwissFieldBase<any>[]) {
        if (mySwissFields) {
            for (const swissField of mySwissFields) {
                const value = this.formGrp.value[swissField.options.key as keyof ObjektModels.ObjektElement];
                if (value && swissField.options.dataBinding) {
                    if (swissField.controlType === 'date_with_time') {
                        const datumMitZeit = value.substring(6, 4) + '-' + value.substring(3, 2) + '-' + value.substring(0, 2) + 'T' + value.substring(11, 8);
                        (this.currObjekt as any)[swissField.options.dataBinding as keyof ObjektModels.ObjektElement] = new Date(datumMitZeit);
                    } else {
                        (this.currObjekt as any)[swissField.options.dataBinding as keyof ObjektModels.ObjektElement] = value;
                    }
                }
            }
        }
    }

    onSubmit() {
        if (this.toggle !== 'mutieren') {
            return;
        }
        // Neues oder bestehendes Objekt wird gespeichert
        this.saveDefaultFormValuesToObject();
        this.saveFormValuesToObject(this.mySwissFieldsObjectDetailLinks);
        this.saveFormValuesToObject(this.mySwissFieldsObjectDetailRechts);
        this.saveFormValuesToObject(this.mySwissFieldsObjectExtensionLinks);
        this.saveFormValuesToObject(this.mySwissFieldsObjectExtensionRechts);

        // Das Objekt und die Felder müssen übergeben werden, damit ermittelt werden kann,
        // welche Felder, dass aktualisiert werden müssen
        if (this.allDynamicObjectFields) {
            if (this.updatedFieldKey != '') {
                // Einzelnes Feld aktualisieren
                if (this.updatedFieldKey === 'manuDesc' || this.updatedFieldKey === 'memo') {
                    let dbField: string;
                    if (this.updatedFieldKey === 'manuDesc') {
                        dbField = 'manufacturingDescription';
                    }// Gross-/Kleinschreibung wichtig!!!!
                    else {
                        dbField = 'memo';
                    }

                    this.svcObjekte
                        .updateObjektField(this.currObjekt, dbField)
                        .subscribe({
                            next: (res: any) => {
                                if (this.swissSettings.getWebConfig().debugMode) {
                                    console.log('Objekt erfolgreich aktualisiert', res);
                                }
                            }, error: (err: any) => {
                                console.error('Das Objekt konnte nicht aktualisiert werden!!!', err);
                                this.svcMessageBox.showError('Das Objekt konnte nicht aktualisiert werden!!', '!! FEHLER !!');
                            }
                        });
                } else {
                    this.svcObjekte
                        .updateObjekt(this.currObjekt, this.allDynamicObjectFields.filter((i) => i.options.key === this.updatedFieldKey))
                        .subscribe({
                            next: (res: any) => {
                                this.toastr.success('Objekt erfolgreich aktualisiert');
                                if (this.swissSettings.getWebConfig().debugMode) {
                                    console.log('Objekt erfolgreich aktualisiert', res);
                                }
                            }, error: (err: any) => {
                                console.error('Das Objekt konnte nicht aktualisiert werden!!!', err);
                                this.svcMessageBox.showError('Das Objekt konnte nicht aktualisiert werden!!', '!! FEHLER !!');
                            }
                        });
                }
            } else {
                // Alle Objekt-Felder aktualisieren
                this.svcObjekte
                    .updateObjekt(this.currObjekt, this.allDynamicObjectFields.filter((i) => i.options.key !== 'ObjCreatedDate' && i.options.key !== 'ObjCreatedBy'))
                    .subscribe({
                        next: (res: any) => {
                            if (this.swissSettings.getWebConfig().debugMode) {
                                console.log('Objekt erfolgreich aktualisiert', res);
                            }
                        }, error: (err: any) => {
                            console.error('Das Objekt konnte nicht aktualisiert werden!!!', err);
                            this.svcMessageBox.showError('Das Objekt konnte nicht aktualisiert werden!!', '!! FEHLER !!');
                        }
                    });
            }
        }
    }

    getOfflineState(): string {
        if (this.currObjektOfflineStatus) {
            return this.formatDate(this.currObjektOfflineStatus.abzugDatum);
        }
        return '';
    }

    delContactPersonLink(element: ObjektModels.ObjektAdresse) {
        let fullName: string;
        if (element.firstName) {
            fullName = element.firstName + ' ' + element.lastName;
        } else {
            fullName = element.lastName;
        }

        this.svcMessageBox.askYesNoQuestion('MAIN_APP_DIALOG.DEL_ADDRESS_REF.msg', 'MAIN_APP_DIALOG.DEL_ADDRESS_REF.title', [fullName]).then((value) => {
            if (value) {
                this.svcObjekte.delObjectAddress(element.id).subscribe({
                    next: () => {
                        this.reloadObjektAdressen();
                    }, error: (err: any) => {
                        console.error('Die Objektadresse konnte nicht entfernt werden. Fehler! ', err);
                        this.svcMessageBox.showError('Die Objektadresse konnte nicht entfernt werden!!', '!! FEHLER !!');
                    }
                });
            }
        });
    }

    changeContactPerson(element: ObjektModels.ObjektAdresse) {
        this.objektAdresseDialogInput = {
            objektAdresseZuord: {
                id: element.id, objectID: this.currObjektID, addressType: element.addressType, addressContact: 0, adressNumber: 0, adressID: element.adressID, contactID: element.contactID,
            }, blDoCheckUnique: true, blDisableAdrTypeSelect: false,
        };

        const dialogRef = this.dialog.open(ObjektAdresseComponent, {
            disableClose: true, width: '95%', data: this.objektAdresseDialogInput,
        });
        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.objektAdresseDialogInput!.objektAdresseZuord = result;
                    if (this.objektAdresseDialogInput!.objektAdresseZuord) {
                        this.svcObjekte.addObjectAddress(this.objektAdresseDialogInput!.objektAdresseZuord)
                            .subscribe({
                                next: () => {
                                    this.reloadObjektAdressen();
                                }, error: (err: any) => {
                                    console.error('objekte.componnent.ts:changeContactPerson(): Fehler: ', err);
                                    this.svcMessageBox.showError('Die Objektadresse konnte nicht entfernt werden!!', '!! FEHLER !!');
                                }
                            });
                    }
                }
            },
        });
    }

    copyAddressesOnSubObjects(element: ObjektModels.ObjektAdresse) {
        let fullName: string;
        if (element.firstName) {
            fullName = element.firstName + ' ' + element.lastName;
        } else {
            fullName = element.lastName;
        }

        this.svcMessageBox
            .askYesNoQuestion('MAIN_APP_DIALOG.COPY_ADDRESS_REF.msg', 'MAIN_APP_DIALOG.COPY_ADDRESS_REF.title', [fullName])
            .then((value) => {
                if (value) {
                    this.svcObjekte.copyObjectAddressTopDown(element.id).subscribe({
                        next: () => {
                        }, error: (err: any) => {
                            console.error('Fehler beim Kopieren der Adresszuordnungen auf die Unterobjekte', err);
                            this.svcMessageBox.showError('Fehler beim Kopieren der Adresszuordnungen auf die Unterobjekte', '!! FEHLER !!');
                        },
                    });
                }
            });
    }

    showImage(element: ObjektModels.ObjektAktivitaetListElement) {
        this.svcDokuData
            .getOtherDokumentFile(element.id, element.documentName)
            .then((value) => {
                if (value) {
                    const dokument: DokumentModels.DokumentBild = {
                        objectID: element.objectID, documentID: element.id, fileName: element.documentName, binary: value, doEdit: false,
                    };
                    this.dialog.open(ImageEditorComponent, {
                        disableClose: true, data: dokument,
                    });
                }
            });
    }

    getImage() {
        const dialogRef = this.dialog.open(CameraViewerComponent, {
            disableClose: true, panelClass: 'webcam-dialog-container',
        });

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    console.log('resu', result);

                    const fileName: string = result.imageName + '.jpeg';
                    const file = new File([result.imageBlob], 'fileName');

                    const dokuInfo: DokumentModels.DokumentBild = {
                        objectID: this.currObjektID, documentID: uuidv4(), fileName, binary: file, doEdit: false,
                    };

                    // Speichert das Bild in der IndexedDB und sendet es an den Webservice
                    this.svcDokuData.uploadBild(dokuInfo).subscribe({
                        next: (res) => {
                            if (this.swissSettings.getWebConfig().debugMode) {
                                console.log(res);
                            }
                            this.svcMessageBox.showSuccess('Das Kamera-Bild wurde erfolgreich gespeichert.', 'Erfolgreich');
                            this.reloadObjektAktivitaeten();
                        }, error: (err) => {
                            if (err.error.code == 'IllegalFileName') {
                                this.svcMessageBox.showErrorByLanguageKey('MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.title');
                            } else {
                                this.svcMessageBox.showError('Das Bild konnte nicht gespeichert werden!!', '!! FEHLER !!');
                            }
                        }
                    });
                }
            },
        });
    }

    saveImage(event: any) {
        const files = event.target.files;
        const fileName: string = files[0].name;
        const file = new File([new Blob([files[0]], {type: files[0].type})], 'fileName');

        const dokuInfo: DokumentModels.DokumentBild = {
            objectID: this.currObjektID, documentID: uuidv4(), fileName, binary: file, doEdit: false,
        };

        // Speichert das Bild in der IndexedDB und sendet es an den Webservice
        this.svcDokuData.uploadBild(dokuInfo).subscribe({
            next: () => {
                this.svcMessageBox.showSuccess('Das Bild wurde erfolgreich gespeichert.', 'Erfolgreich');
                this.reloadObjektAktivitaeten();
            }, error: (err) => {
                if (err.error.code == 'IllegalFileName') {
                    this.svcMessageBox.showErrorByLanguageKey('MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.title');
                } else {
                    this.svcMessageBox.showError('Das Bild konnte nicht gespeichert werden!!', '!! FEHLER !!');
                }
            }
        });
    }

    editImage(element: ObjektModels.ObjektAktivitaetListElement) {
        this.svcDokuData
            .getOtherDokumentFile(element.id, element.documentName)
            .then((value) => {
                if (value) {
                    const dokument: DokumentModels.DokumentBild = {
                        objectID: element.objectID, documentID: element.id, fileName: element.documentName, binary: value, doEdit: true,
                    };
                    this.dialog.open(ImageEditorComponent, {
                        disableClose: true, width: '800px', data: dokument,
                    });
                }
            });
    }

    delImage(element: ObjektModels.ObjektAktivitaetListElement) {
        this.svcMessageBox
            .askYesNoQuestion('MAIN_APP_DIALOG.DEL_IMG.msg', 'MAIN_APP_DIALOG.DEL_IMG.title', [element.documentName])
            .then((value) => {
                if (value) {
                    this.svcObjekte
                        .deleteObjektAktivitaet(this.currObjektID, element.id, element.art)
                        .subscribe({
                            next: (res: any) => {
                                if (res) {
                                    this.reloadObjektAktivitaeten();
                                }
                            }, error: () => {
                                console.error('Fehler beim Löschen des Bildes!');
                                this.svcMessageBox.showError('Das Bild konnte nicht gelöscht werden. ', '!! FEHLER !!');
                            }
                        });
                }
            });
    }

    delActivity(element: ObjektModels.ObjektAktivitaetListElement) {
        this.svcMessageBox
            .askYesNoQuestion('MAIN_APP_DIALOG.DEL_OBJ_ACTIVITY.msg', 'MAIN_APP_DIALOG.DEL_OBJ_ACTIVITY.title',)
            .then((value) => {
                if (value) {
                    // Notiz in der Indexed-DB löschen
                    this.svcDokuData.delLocalNotizblatt(element.id);

                    // Notiz via Webservice löschen
                    this.svcObjekte
                        .deleteObjektAktivitaet(this.currObjektID, element.id, element.art)
                        .subscribe({
                            next: (res: any) => {
                                if (res) {
                                    this.reloadObjektAktivitaeten();
                                }
                            }, error: () => {
                                console.error('Fehler beim Löschen einer Objektaktivität');
                                this.svcMessageBox.showError('Die Objektaktivität konnte nicht gelöscht werden. ', '!! FEHLER !!');
                            }
                        });
                }
            });
    }

    rteActionBegin(event: any) {
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('rteActionBegin() is called', event);
        }
        // if (event.requestType === 'Maximize') this.homeLayoutComponent.closeMenu();
        // if (event.requestType === 'Minimize') this.homeLayoutComponent.openMenu();
    }

    rteContentChange(event: any, formControlName: string) {
        console.log('rteContentChange() is called', event);
        this.formGrp.controls[formControlName].patchValue(event.value);
        this.updatedFieldKey = formControlName;
        this.onSubmit();
    }

    neueNotiz() {
        const user = this.userAuthService.getCurrentAuthenticatedUser()!;
        const now = new Date();
        this.dataForCalendarNote = {
            notiz: {
                noteID: uuidv4(), objectID: '', objDesc: '', adressID: undefined, contactID: undefined, responsible: user.loginname, created: now, createdBy: user.loginname, modified: now, modifiedBy: user.loginname, notes: '', description: '', done: 0, private: false, wasRead: 0,
            }, mitarbeiter: [], notizKategorien: [], istNeueNotiz: true,
        };
        const objectID = this.svcObjektData.getCurrentObjectID();

        if (objectID) {
            this.dataForCalendarNote!.notiz.objectID = objectID;
        }

        const dialogRef = this.dialog.open(NotizEintragComponent, {
            disableClose: true, data: this.dataForCalendarNote,
        });

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.currNotizMitBenutzern = result;
                    if (this.currNotizMitBenutzern) {
                        this.svcMainData.saveNotiz(this.currNotizMitBenutzern).subscribe({
                            next: () => {
                                this.svcMessageBox.showSuccess('Die Notiz wurde erfolgreich gespeichert.', 'Erfolgreich');
                                this.svcObjektData.reloadObjActivities();
                                this.svcDashboard.reloadDashboardBadgeIcons();
                                this.svcMainData.refreshNoteCount();
                            }, error: (error) => {
                                console.log(error);
                                this.svcMessageBox.showError('Die Notiz konnte nicht gespeichert werden!!', '!! FEHLER !!');
                            },
                        });
                    }
                }
            },
        });
    }

    logout(): void {
        this.userAuthService.logoutUser('/login');
    }

    back() {
        // current page
        this.prevToggleValue.pop();
        const prev = this.prevToggleValue.pop();
        if (prev) {
            this.toggleBtn(prev);
        }
    }

    /* Ende RichtText Editor */

    toggleBtn(value: string) {
        if ((value == 'adressen' || value == 'objekt-aktivitat' || value == 'objektansicht' || value == 'teilen' || value == 'mutieren') && !this.currObjektID && value != this.toggle) {
            this.toastr.error('Bitte Objekt auswählen');
            return;
        }
        if (value === 'baum' && this.currObjektID) {
            this.loadSingleObjekt(true);
        }

        this.filteredDescriptions = this.objekte;
        this.prevToggleValue.push(value);

        // TODO do it by language key
        switch (value) {
            case 'adressen':
                this.toggle = 'adressen';
                this.headerTitle = 'Adressen - ' + this.currObjekt.description;
                break;
            case 'baum':
                this.toggle = 'baum';
                this.headerTitle = 'Objektsuche';
                break;
            case 'objekt-aktivitat':
                this.toggle = 'objekt-aktivitat';
                this.headerTitle = 'Aktivitäten - ' + this.currObjekt.description;
                break;
            case 'mutieren':
                this.toggle = 'mutieren';
                break;
            case 'objektansicht':
                this.toggle = 'objektansicht';
                this.headerTitle = 'Objekt - ' + this.currObjekt.description;
                break;
            case 'teilen':
                this.toggle = 'teilen';
                this.headerTitle = 'Teilen - ' + this.currObjekt.description;
                break;
            default:
                this.toggle = 'suchen';
                this.headerTitle = 'Objektsuche';
        }
    }

    private resetFormGroup() {
        if (this.formGrp.contains('manuDesc')) {
            this.formGrp.controls.manuDesc.patchValue(this.currObjekt.manufacturingDescription);
        }

        if (this.formGrp.contains('memo')) {
            this.formGrp.controls.memo.patchValue(this.currObjekt.memo);
        }

        if (this.allDynamicObjectFields) {
            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('ResetFormGroup', this.allDynamicObjectFields, this.formGrp);
            }
            this.allDynamicObjectFields.forEach((formItem) => {
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('formItem', formItem);
                }
                this.formGrp.controls[formItem.options.key!]?.patchValue(formItem.options.value);
            });
        }
    }

    private openPDFViewerDialog() {
        this.dialog.open(PDFViewerDialogComponent, {
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: '100%',
            width: '100%',
            data: {isDialogMode: true}
        });
    }

    private initData() {
        if (this.helperService.isWebServiceAvailable()) {
            this.refreshSuchfeldBeschreibungen();
        } else {
            this.refreshOfflineSuchfeldBeschreibungen();
        }

        // Übergebens Objekt vom Dashboard loaden (Darf erst gemacht werden, wenn die treeviewitems vorhanden sind => refreshObjektBaum)
        this.sub = this.route.params.subscribe({
            next: (params) => {
                this.currObjektID = params.id;
                if (this.currObjektID) {
                    this.loadSingleObjekt(true);
                }
            },
        });
    }

    private loadSingleObjekt(blShowObjektInTreeview: boolean = false) {
        this.objectDataLoaded = false;
        this.updatedFieldKey = '';

        this.setExpandStateObjektDetails(0); // Panel Objekt-Details öffnen
        if (this.helperService.isWebServiceAvailable()) {
            this.svcObjekte.getObjektByID(this.currObjektID).subscribe({
                next: (res: ObjektModels.ObjektElement) => {
                    this.currObjekt = res;

                    // via Service den anderen Komponenten das Objekt mitteilen
                    this.svcObjekte.setCurrentObject(this.currObjekt);
                    this.loadObjektAditionalData(blShowObjektInTreeview);
                }, error: () => {
                    this.ngOnInit();
                },
            });
        } else {
            this.svcObjekte.getOfflineObjektByID(this.currObjektID).subscribe({
                next: (obj: ObjektModels.ObjektElement) => {
                    if (obj) {
                        this.currObjekt = obj;
                        // via Service den anderen Komponenten das Objekt mitteilen
                        this.svcObjekte.setCurrentObject(this.currObjekt);
                        // Formularwerte neu setzen --> DataBinding
                        this.fillOfflineFormDataValues();
                        // Objektadressen laden
                        this.reloadObjektAdressen();
                        // Objekt-Aktivitäten (Dokumente) laden
                        this.reloadObjektAktivitaeten();

                        if (blShowObjektInTreeview) {
                            // this.showObjectInTreeview();
                        }
                    }
                }, error: () => {
                }
            });
        }
    }

    private onNewBaseObjekt() {
        this.dataSourceObjektAdressen!.data = [];
        this.hasObjektPartner = 0;
        this.dataSourceObjektAktivitaeten!.data = [];
        this.formGrp = this.fb.group({}); // Damit keine alten Felder geladen werden
        this.hasObjektDokus = 0;

        // Objektdetails öffnen
        this.setExpandStateObjektDetails(0);

        // Objekterweiterung schliessen
        this.setExpandStateObjektErweiterung(1);

        // Objekt-Aktivitäten schliessen
        this.setExpandStateObjektAktivitaeten(1);

        // Objekt-Adressen öffnen
        this.setExpandStateObjektAdressen(0);

        // Dokumentinfos schliessen
        this.setExpandStateObjektDokuInfos(1);
    }

    private delObjekt() {
        const parentObjectID = this.currObjekt.parentObject;
        this.svcObjekte.deleteObjekt(this.currObjekt).subscribe({
            next: (res: any) => {
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('onDelObjekt', res);
                }
                // Item aus TreeView entfernen
                // this.removeObjektFromBaum();
                // Suchbeschreibungen neu laden
                this.removeSuchfeldBeschreibungen();
                this.objectDataLoaded = false;
                if (parentObjectID) {
                    this.currObjektID = parentObjectID;
                    this.loadSingleObjekt(true);
                } else {
                    this.cleanObjectData();
                }
                this.svcMessageBox.showSuccess('Das Objekt wurde erfolgreich gelöscht. ', 'Erfolgreich');
            }, error: (err: any) => {
                console.error(err);
                this.svcMessageBox.showError('Das Objekt konnte nicht gelöscht werden!!', '!! FEHLER !!');
            }
        });
    }
}
